import { IAuthService } from './auth.service'

export class NoopAuthService implements IAuthService {
  async getToken(): Promise<string | undefined> {
    return undefined
  }
}
